import React, { Component } from "react";
import { UploadPanel } from "../components";
import { constant } from "../helpers";
import "./Site.css";
import { Redirect } from "react-router-dom";

export default class PartsUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToParts: false
    };
  }

  render() {
    if (this.state.redirectToParts) {
      return <Redirect to="/admin" />;
    }

    return (
      <div>
        <UploadPanel
          uploadType={constant.uploadType.part}
          onSuccess={() => this.setState({ redirectToParts: true })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PartsUpload.js